import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Loader/loader/loader.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import * as XLSX from 'xlsx';
import { CommonService } from '../../../Model/Common/common.service';
import { AlertWarningComponent } from '../../Alert/alert-warning/alert-warning.component';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ShiftGroupService } from '../../../Model/ShiftGroup/shift-group.service';
import { LocationServiceService } from '../../../Model/LocationMaster/location-service.service';
import e from 'express';
import { ComboService } from '../../../Model/Combo/combo.service';
import { EmployeeLeaveManagementService } from '../../../Model/EmployeeLeaveManagement/employee-leave-management.service';
import { AlertSuccessComponent } from '../../Alert/alert-success/alert-success.component';
import { SiteTypeService } from '../../../Model/SiteType/site-type.service';
import { ShiftService } from '../../../Model/Shift/shift.service';

@Component({
  selector: 'app-common-upload',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, LoaderComponent],
  providers: [DatePipe],
  templateUrl: './common-upload.component.html',
  styleUrl: './common-upload.component.scss'
})
export class CommonUploadComponent {
  isDisabled: boolean = false;
  @Input() Input_ExcelUploadMasterID: number = 0;

  anyonesuccess = false;
  uploadfile = null as any;
  //ExcelData: any[] = [];
  excelcheck = false;
  recodecheck = false;
  allowsubmit = false;
  ExcelHeadersIndex = null as any;

  excelHeader = [] as any;
  excelHeader2 = [] as any;
  excelHeader3 = [] as any;
  excelData = [] as any;
  excelData2 = [] as any;
  excelData3 = [] as any;
  excelDataResult = [] as any;
  excelDataResult2 = [] as any;
  excelDataResult3 = [] as any;

  IndustrySeg = [] as any;
  ServiceType: any[] = [];
  RegionMaster: any[] = [];
  BranchMaster: any[] = [];
  CustomerGroup: any[] = [];
  BillingCustomer: any[] = [];
  FinancialBranch: any[] = [];
  Group: any[] = [];
  State: any[] = [];
  District: any[] = [];
  Taluka: any[] = [];
  ZoneMaster: any[] = [];
  SiteOwner: any[] = [];
  ReportTypeMaster: any[] = [];
  DesignationLoad: any[] = [];
  DutyLoad: any[] = [];
  Shift: any[] = [];
  ManPowerTable: any[] = [];
  SiteType: any[] = [];
  Channels: any[] = [];
  Banks: any[] = [];
  AttendanceThroughLoad: any[] = [];
  LeaveSalaryCycleLoad: any[] = [];
  LeaveSalaryPayoutLoad: any[] = [];
  PayoutBonusesCycleLoad: any[] = [];
  PayoutBonusLoad: any[] = [];
  GratuityLoad: any[] = [];
  UniformLoad: any[] = [];
  MinimumWageIndustryLoad: any[] = [];
  MinimumWageZoneLoad: any[] = [];
  WageStrutureLoad: any[] = [];
  Groups: any[] = [];
  SubGroups: any[] = [];
  FilteredSubGroups: any[] = [];

  ShiftGroup: any[] = [];

  BillTypes = ['Fixed Billing', 'Muster Billing', 'BillOnSalaryCTC'];
  Compliance = ['Compliance', 'Non-Compliance'];
  MaterialChargesType = ['Fixed Value', 'Rate / Sq. Ft.', 'Percentage', 'At Actual'];
  MachineryChargesType = ['Fixed Value', 'Percentage'];
  SalaryBillingCalcOn = [{ Name: 'Total Month Days', Value: 'M' },
  { Name: 'Total Working Days', Value: 'W' },
  { Name: 'Per Day', Value: 'P' },
  { Name: 'Fix Days', Value: 'F' },
  { Name: 'Month Days', Value: 'S' },]

  ExcelHeaders = [
    {
      ESS_ExcelUploadMasterID: 1,//ShiftMaster
      Headers: ['ShiftMasterid', 'ShiftCode', 'ShiftTitle', 'InTime', 'OutTime', 'DefaultShift', 'RotationalShift', 'ShiftGroupName'],
      SampleFileName: 'ShiftMaster' as any
    },
    {
      ESS_ExcelUploadMasterID: 2,//ShiftGroupMaster
      Headers: ['ESS_ShiftGroupMasterID', 'ShiftGroupName'],
      SampleFileName: 'ShiftGroupMaster' as any
    },
    // {
    //   ESS_ExcelUploadMasterID: 3,//RoleMaster
    //   Headers: ['WebESSRoleMasterID', 'RoleName'],
    // }, 
    {
      ESS_ExcelUploadMasterID: 4,//SiteTypeMaster
      Headers: ['SiteTypeMasterID', 'SiteTypeName'],
      SampleFileName: 'SiteTypeMaster' as any
    },
    {
      ESS_ExcelUploadMasterID: 5,//Site Master
      Headers: ['Location ID', 'Location Code', 'Location Name', 'Branch Name', 'Client Group Code', 'Client Group Name', 'Max Client Name', 'IndustrySegmentGroupName', 'IndustrySegmentName',
        'Rate Contract Group', 'Zone Name', 'SiteGroupName', 'SiteSubGroupName', 'ChannelGroupName', 'ChannelName', 'ServiceTypeName', 'BankName', 'Address1', 'Address2',
        'City', 'State Name', 'District Name', 'Taluka Name', 'PinCode', 'TelephoneNo', 'Contact Person Name', 'Contact Person TelNo', 'Contact Person Email', 'BillType',
        'Compliance', 'PFApplicable', 'ESICApplicable', 'PTApplicable', 'LWFApplicable', 'OpenMonth', 'OpenYear', 'SiteStartDate', 'SiteEndDate', 'Remark', 'IsMapped',
        'SiteOwnerName', 'Latitude', 'Longitude', 'Radius', 'Accuracy', 'Altitude', 'heading', 'isMocked', 'IsAltitudeApplicable', 'AltitudeRadius', 'Multiple Gate', 'Area(SqFt)',
        'Material Charge', 'Material Charge Type', 'Machinery Charge Type', 'Machinery Charge', 'Salary Calc Type', 'Salary From', 'Salary To', 'Salary Calc On', 'Billing Calc Type',
        'Billing From', 'Billing To', 'Billing Calc On', 'Site Creation Date', 'IsInternalPOCApplicable', 'InternalPOCName', 'InternalPOCMobileNo', 'InternalPOCMailId', 'IsClientPOCApplicable',
        'ClientPOCName', 'ClientPOCMobileNo', 'ClientPOCMailId', 'SiteOracleCode', 'SiteAlternateCode', 'SiteAgreementCopyAttachment', 'SiteAttendanceThrough', 'SiteLeaveSalarCycle',
        'SiteLeaveSalary', 'SitePayoutBonusesCycle', 'SitePayoutBonus', 'SiteGratuity', 'SiteUniforms', 'SiteIsUniformsDeposit', 'SiteMinimumWageIndustry', 'SiteMinimumWageZone', 'SiteMinimumWageStructure',
        'SiteBillTo', 'SiteShipTo', 'SiteAutoMail', 'SitePlaceOfSupplyApplicable', 'SiteDefaultNarration', 'IsClientAttendanceInformationMail',
        'FinancialBranch', 'BillDutyDivisionBy', 'WeeklyOffDivisionBy',
        'NewLateralSite', 'AttendanceDate', 'SalaryDate', 'SalaryPayDate', 'BillingDate', 'IsActive', 'SrNo'],
      HeadersSiteManpower: ['SrNo', 'Designation', 'Duty', 'NoOfPerson', 'SalaryCalcOn', 'SalaryCalcDays', 'BillingCalcOn', 'BillingCalcDays', 'ProductDescription'] as any,
      HeadersShiftDetail: ['SrNo', 'Designation', 'Duty', 'Shift', 'ShiftWiseNoOfPerson'] as any,
      SampleFileName: 'SiteMaster' as any
    },
    {
      ESS_ExcelUploadMasterID: 6, //Leave Detail
      Headers: ['Emp Master ID', 'Leave Master ID', 'Input Type', 'Value', 'Remark'],
      SampleFileName: 'Leave Details'
    }
  ];

  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private modalService: NgbModal,
    private download: DownloadSampleService,
    private shift: ShiftGroupService,
    private shiftmaster: ShiftService,
    private locationservice: LocationServiceService,
    private comboload: ComboService,
    private activeModal: NgbActiveModal,
    private datePipe: DatePipe,
    public leave: EmployeeLeaveManagementService,
    private sitetype: SiteTypeService
  ) {
    //this.common.getPageRights();
  }

  handleFileInputChange(event: any): void {
    //this.ExcelData = [];
    const files: FileList = event.target.files;

    const input = event.target as HTMLInputElement;

    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      } else {
        this.uploadfile = file;
      }
      //this.processExcelFile(file);
      event.target.value = '';
    }
  }

  ngOnInit(): void {
    this.ExcelHeadersIndex = this.ExcelHeaders.findIndex(e => e.ESS_ExcelUploadMasterID == this.Input_ExcelUploadMasterID);
  }

  processExcelFile(file: File): void {
    this.isDisabled = true;
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        let sheetName = 'Sheet1';
        let sheetName2 = 'Sheet2';
        let sheetName3 = 'Sheet3';

        if (this.Input_ExcelUploadMasterID == 5) {
          sheetName = 'Site Master';
          sheetName2 = 'Site Manpower';
          sheetName3 = 'Shift Manpower';
        }

        if (!workbook.SheetNames.includes(sheetName)) {
          let errorMessage = sheetName + ' not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        let excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        let excelData2;
        let excelData3;
        if (this.Input_ExcelUploadMasterID == 5) {
          const worksheet2 = workbook.Sheets[sheetName2];
          const worksheet3 = workbook.Sheets[sheetName3];
          excelData2 = XLSX.utils.sheet_to_json(worksheet2, { header: 1 }) as any[][];
          excelData3 = XLSX.utils.sheet_to_json(worksheet3, { header: 1 }) as any[][];
        }

        if (excelData.length > 1) {
          const headerRow = excelData[0];
          const headers = headerRow.map((header: string) => header.replace(/\s+/g, ''));
          this.allowsubmit = false;
          this.excelcheck = true;

          if (this.ExcelHeaders.length > 0) {
            this.ExcelHeaders[this.ExcelHeadersIndex].Headers.forEach(element => {
              if (this.excelcheck) {
                if (headers.findIndex(e => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element.replace(/\s+/g, ''))) >= 0) {
                  this.excelcheck = true;
                } else {
                  this.excelcheck = false;
                }
              }

              if (!this.excelcheck) {
                return;
              }
            });
          }

          if (!this.excelcheck) {
            this.reset();
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Excel file column not match. please check sample file";
            modalRef.result.then((result: any) => { });
          } else {
            this.allowsubmit = true;
            if (this.Input_ExcelUploadMasterID == 6) {
              excelData = XLSX.utils.sheet_to_json(worksheet);
              console.log(excelData);
            }
            this.submit(excelData, excelData2, excelData3);
          }
          this.isDisabled = false;
        } else {
          this.reset();
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Excel file have a no data";
          modalRef.result.then((result: any) => { });
        }
      } else {
        console.error('Failed to read the file.');
        this.isDisabled = false;
      }
    };
    reader.readAsBinaryString(file);
  }

  uploadfileData() {
    const file: File = this.uploadfile;
    const fileType: string | undefined = file.name.split('.').pop();
    if (fileType !== 'xlsx' && fileType !== 'xls') {
      this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
      return;
    }
    this.processExcelFile(file);
  }

  reset() {
    this.isDisabled = false;
    this.allowsubmit = false;
    this.removeFile();
  }

  removeFile() {
    this.setallowsubmit();
    this.uploadfile = null;
  }

  setallowsubmit() {
    this.allowsubmit = false;
  }

  downloadExcel() {
    if (this.ExcelHeadersIndex >= 0) {
      this.download.downloadExcel(this.ExcelHeaders[this.ExcelHeadersIndex].SampleFileName);
    } else {
      this.toast.show({ message: 'file not found.', type: toastTypeEnum.warning });
    }
  }

  submit(excelDatas: any, excelDatas2: any, excelDatas3: any) {
    if (this.allowsubmit) {
      this.excelHeader = [];
      this.excelData = [];
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(async result => {
        if (result) {
          if (this.Input_ExcelUploadMasterID == 5) {
            await this.loadSiteData(null);
          } else if (this.Input_ExcelUploadMasterID == 1) {
            await this.ComboLoad("ShiftGroup");
          }

          if (this.Input_ExcelUploadMasterID == 6) {
            console.log(excelDatas);
            this.SaveLeaveDetail(excelDatas);
            return;
          }

          this.excelHeader = excelDatas[0];
          if (this.Input_ExcelUploadMasterID == 5) {
            this.excelHeader2 = excelDatas2[0];
            this.excelHeader3 = excelDatas3[0];
          }

          this.excelData = excelDatas.slice(1);
          if (this.Input_ExcelUploadMasterID == 5) {
            this.excelData2 = excelDatas2.slice(1);
            this.excelData3 = excelDatas3.slice(1);
          }

          this.isDisabled = true;
          this.excelDataResult = [];
          this.excelDataResult2 = [];
          this.excelDataResult3 = [];
          let rindex2e = 0;
          let rindex3e = 0;
          for (let rindex = 0; rindex < this.excelData.length; rindex++) {
            const element = this.excelData[rindex];
            this.excelDataResult[rindex] = {};
            element.Result = "";
            this.recodecheck = true;
            if (this.Input_ExcelUploadMasterID == 1) {
              const ShiftMasterdetail = {
                SelectType: null as any,
                ShiftMasterid: null as any,
                ShiftCode: null as any,
                ShiftTitle: null as any,
                InTime: null as any,
                OutTime: null as any,
                DefaultShift: null as any,
                RotationalShift: null as any,
                ESS_ShiftGroupMasterID: null as any,
              }
              let intime = [];
              let outtime = [];
              for (const [index, helement] of this.ExcelHeaders[this.ExcelHeadersIndex].Headers.entries()) {
                this.excelDataResult[rindex][helement] = element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement.replace(/\s+/g, '')))];
                const excelHIndex = this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement.replace(/\s+/g, '')));

                if (excelHIndex >= 0 && element[0] != undefined) {
                  if (index == 0) {
                    if (element[excelHIndex].toString().replace(/\s+/g, '') != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && element[excelHIndex] > 0) {
                      ShiftMasterdetail.SelectType = 'update';
                      ShiftMasterdetail.ShiftMasterid = element[excelHIndex];
                    } else {
                      ShiftMasterdetail.SelectType = 'insert';
                    }
                  }
                  if (index == 1) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      ShiftMasterdetail.ShiftCode = element[excelHIndex];
                    } else {
                      element.Result += "Shift Code blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 2) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      ShiftMasterdetail.ShiftTitle = element[excelHIndex];
                    } else {
                      element.Result += "Shift Title blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 3) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (!isNaN(element[excelHIndex])) {
                        element[excelHIndex] = formatExcelTimeTo24Hour(element[excelHIndex])
                      }
                      intime = element[excelHIndex].split(":");
                      if (intime.length == 2) {
                        if ((!isNaN(intime[0]) && parseInt(intime[0].toString().replace(/\s+/g, '')) <= 23 && parseInt(intime[0].toString().replace(/\s+/g, '')) >= 0)
                          && (!isNaN(intime[1]) && parseInt(intime[1].toString().replace(/\s+/g, '')) <= 59 && parseInt(intime[1].toString().replace(/\s+/g, '')) >= 0)) {
                          ShiftMasterdetail.InTime = element[excelHIndex];
                        } else {
                          element.Result += "In Time allow betweem 00:00 to 23:59;";
                          this.recodecheck = false;
                        }
                      } else {
                        element.Result += "In Time allow formate HH:MM;";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "In Time blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 4) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (!isNaN(element[excelHIndex])) {
                        element[excelHIndex] = formatExcelTimeTo24Hour(element[excelHIndex])
                      }
                      outtime = element[excelHIndex].split(":");
                      if (outtime.length == 2) {
                        if ((!isNaN(outtime[0]) && parseInt(outtime[0].toString().replace(/\s+/g, '')) <= 23 && parseInt(outtime[0].toString().replace(/\s+/g, '')) >= 0)
                          && (!isNaN(outtime[1]) && parseInt(outtime[1].toString().replace(/\s+/g, '')) <= 59 && parseInt(outtime[1].toString().replace(/\s+/g, '')) >= 0)) {
                          ShiftMasterdetail.OutTime = element[excelHIndex];
                        } else {
                          element.Result += "Out Time allow betweem 00:00 to 23:59;";
                          this.recodecheck = false;
                        }
                      } else {
                        element.Result += "Out Time allow formate HH:MM;";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Out Time blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 5) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      ShiftMasterdetail.DefaultShift = true;
                    } else {
                      ShiftMasterdetail.DefaultShift = false;
                    }
                  }
                  if (index == 6) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      ShiftMasterdetail.RotationalShift = true;
                    } else {
                      ShiftMasterdetail.RotationalShift = false;
                    }
                  }
                  if (index == 7) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.ShiftGroup.findIndex(e => this.common.ToLowerCase(e.ShiftGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        ShiftMasterdetail.ESS_ShiftGroupMasterID = this.ShiftGroup[this.ShiftGroup.findIndex(e => this.common.ToLowerCase(e.ShiftGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].ESS_ShiftGroupMasterId;
                      } else {
                        element.Rexsult += "Shift Group not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Shift Group blank not allow; ";
                      this.recodecheck = false;
                    }
                  }

                  if (index == 7) {
                    if (!ShiftMasterdetail.RotationalShift) {
                      if (
                        !(parseInt(outtime[0].toString().replace(/\s+/g, '')) > parseInt(intime[0].toString().replace(/\s+/g, ''))
                          ||
                          (
                            parseInt(outtime[0].toString().replace(/\s+/g, '')) == parseInt(intime[0].toString().replace(/\s+/g, ''))
                            &&
                            parseInt(outtime[1].toString().replace(/\s+/g, '')) > parseInt(intime[1].toString().replace(/\s+/g, ''))
                          ))
                      ) {
                        element.Result += "Out Time must be greater then intime";
                        this.recodecheck = false;
                      }
                    }
                  }
                }
              }
              if (this.recodecheck) {
                await this.SaveandUpdateShiftMaster(ShiftMasterdetail, element);
              }
              this.excelDataResult[rindex].Result = element.Result;
            } else if (this.Input_ExcelUploadMasterID == 2) {
              for (const [index, helement] of this.ExcelHeaders[this.ExcelHeadersIndex].Headers.entries()) {
                this.excelDataResult[rindex][helement] = element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement.replace(/\s+/g, '')))];
              }
              if (element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, '')))] != null
                && element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, '')))] != '') {
                await this.SaveFromExcelShiftGroup(element);
              } else {
                element.Result = "Site group blank not allow";
              }
              this.excelDataResult[rindex].Result = element.Result;
            } else if (this.Input_ExcelUploadMasterID == 4) {
              for (const [index, helement] of this.ExcelHeaders[this.ExcelHeadersIndex].Headers.entries()) {
                this.excelDataResult[rindex][helement] = element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement.replace(/\s+/g, '')))];
              }

              if (element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, '')))] != null
                && element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, '')))] != '') {
                await this.SaveFromExcelSiteType(element);
              } else {
                element.Result = "Site type blank not allow";
              }
              this.excelDataResult[rindex].Result = element.Result;
            } else if (this.Input_ExcelUploadMasterID == 5) {
              const SiteIndertUpdate = {
                SelectType: null as any,
                SiteMasterId: null as any,
                IndustrySegmentID: null as any,
                ServiceTypeID: null as any,
                RegionID: null as any,
                BranchID: null as any,
                ClientGroupId: null as any,
                MaxClientId: null as any,
                SiteCode: null as any,
                SiteName: null as any,
                FinancialBranchID: null as any,
                GroupID: null as any,
                Address1: null as any,
                Address2: null as any,
                City: null as any,
                PinCode: null as any,
                TelephoneNo: null as any,
                StateID: null as any,
                DistrictID: null as any,
                TalukaID: null as any,
                ContactPersonName: null,
                ContactPersonEmail: null,
                ContactPersonNo: null,
                Compliance: null as any,
                BillType: null as any,
                BillDutyDivisionBy: null as any,
                ZoneId: null,
                PFApplicable: null as any,
                ESICApplicable: null as any,
                PTApplicable: null as any,
                LWFApplicable: null as any,
                WeeklyOffDivideBy: null as any,
                PFonBasicDAOT: null,
                AdminChargesApplicable: null,
                OnlineAttendanceFreeze: null,
                Active: true,
                SalaryCalcType: null as any,
                SalaryFrom: null as any,
                SalaryTo: null as any,
                BillingCalcType: null as any,
                BillingFrom: null as any,
                BillingTo: null as any,
                SiteOwnerID: null,
                Latitude: null,
                Longitude: null,
                Accuracy: null,
                Altitude: null,
                Heading: null,
                Radius: null,
                IsMocked: null as any,
                WorkOrderNumber: null,
                ClientSiteCode: null,
                WorkOrderDate: null,
                ValidTill: null,
                WorkOrderValue: null,
                ContractStartDate: null,
                ContractValue: null,
                AnnualValue: null,
                Narration: null,
                AgreementType: null,
                NoOfAgreement: null,
                ReportType: null,
                Tender: null,
                TenureOfContract: null,
                MinimumEscalationClause: null,
                BillingName: null,
                ManpowerCost: null,
                ManpowerOption: null,
                ManpowerValue: null,
                MachineryCost: null,
                MachineryOption: null,
                MachineryValue: null,
                ConsumableCost: null,
                ConsumableOption: null,
                ConsumableValue: null,
                ManagementFees: null,
                MgmtFeesValue: null,
                UniformOption: null,
                SiteType: null as any,
                OtherChargesOption: null,
                OtherCharges: null,
                SiteStartDate: null,
                SiteEndDate: null,
                RBIIndex: null,
                MinWages: null,
                PerIncGrowth: null,
                GuardBoardIndex: null,
                NewIndustrySegment: null,
                SubServiceType: null,
                NewSubLocation1: null,
                NewSubLocation2: null,
                OperationTeamEmailId: null,
                CompNatureofWork: null,
                AreaSqFt: null,
                MaterialChgType: null as any,
                MaterialChgVal: null,
                MachineryChgType: null as any,
                MachineryChgVal: null,
                ESS_SiteManpower: [] as any,
                ESS_ShiftDetails: [] as any,
                UserId: null,

                PPUMachineryCost: null,
                PPUBGCost: null,
                PPUBusinessProvisionPercent: null,
                PPUBusinessProvisionValue: null,
                CISMarginValue: null,
                Sitecount: null,
                ManpowerStrength: null,
                AttendanceDateValue: null as any,
                SalaryDateValue: null as any,
                SalaryPaymentDateValue: null as any,
                BillingDateValue: null as any,
                SiteTypeID: null,

                IsInternalPOCApplicable: null as any,
                InternalPOCName: null,
                InternalPOCMobileNo: null,
                InternalPOCMailId: null,
                IsClientPOCApplicable: null as any,

                // code
                IsClientAttendanceInformationMail: null as any,
                ClientPOCName: null,
                ClientPOCMobileNo: null,
                ClientPOCMailId: null,
                IsAltitudeApplicable: null as any,
                AltitudeRadius: null,

                SiteChannelId: null,
                SiteOracleCode: null,
                SiteAlternateCode: null,
                SiteAgreementCopyAttachment: null,
                SiteBankId: null,
                SiteAttendanceThrough: null,
                SiteLeaveSalarCycle: null,
                SiteLeaveSalary: null,
                SitePayoutBonusesCycle: null,
                SitePayoutBonus: null,
                SiteGratuity: null,
                SiteUniforms: null,
                SiteIsUniformsDeposit: null as any,
                SiteMinimumWageIndustry: null,
                SiteMinimumWageZone: null,
                SiteMinimumWageStructure: null,
                SiteBillTo: null,
                SiteShipTo: null,
                SiteAutoMail: null as any,
                SitePlaceOfSupplyApplicable: null as any,
                SiteDefaultNarration: null,
                SiteSubGroupMasterID: null
              }

              for (const [index, helement] of this.ExcelHeaders[this.ExcelHeadersIndex].Headers.entries()) {
                this.excelDataResult[rindex][helement] = element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement.replace(/\s+/g, '')))];
                const excelHIndex = this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement.replace(/\s+/g, '')));
                //if (excelHIndex >= 0 && this.recodecheck) {
                if (excelHIndex >= 0 && element[0] != undefined) {
                  if (index == 0) {
                    if (element[excelHIndex].toString().replace(/\s+/g, '') != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && element[excelHIndex] > 0) {
                      SiteIndertUpdate.SelectType = 'EU';
                      SiteIndertUpdate.SiteMasterId = element[excelHIndex];
                    } else {
                      SiteIndertUpdate.SelectType = 'EI';
                    }

                  }
                  //else 
                  if (index == 1) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.SiteCode = element[excelHIndex];
                    } else {
                      element.Result += "Location Code blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 2) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.SiteName = element[excelHIndex];
                    } else {
                      element.Result += "Location Name blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 3) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.BranchMaster.findIndex(e => this.common.ToLowerCase(e.BranchName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.BranchID = this.BranchMaster[this.BranchMaster.findIndex(e => this.common.ToLowerCase(e.BranchName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].BranchMasterID;
                        await this.loadSiteData(SiteIndertUpdate.BranchID);
                      } else {
                        element.Result += "Branch Name not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Branch Name blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 4 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  }
                  //else 
                  if (index == 5) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.CustomerGroup.findIndex((e: any) => this.common.ToLowerCase(e.ClientGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.ClientGroupId = this.CustomerGroup[this.CustomerGroup.findIndex((e: any) => this.common.ToLowerCase(e.ClientGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].ClientGroupMasterID;
                        //need to check max Client group
                        await this.BillCustLoad(SiteIndertUpdate.ClientGroupId);
                      } else {
                        element.Result += "Client Group Name not found; ";
                        this.recodecheck = false;
                      }
                    }
                  }
                  //else 
                  if (index == 6 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.BillingCustomer.findIndex((e: any) => this.common.ToLowerCase(e.ClientGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.MaxClientId = this.BillingCustomer[this.BillingCustomer.findIndex((e: any) => this.common.ToLowerCase(e.ClientGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].ClientGroupID;
                    } else {
                      element.Result += "Max Client Name not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 7 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  }
                  //else
                  if (index == 8) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.IndustrySeg.findIndex((e: any) => this.common.ToLowerCase(e.IndustrySegmentName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.IndustrySegmentID = this.IndustrySeg[this.IndustrySeg.findIndex((e: any) => this.common.ToLowerCase(e.IndustrySegmentName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].IndustrySegmentID;
                      } else {
                        element.Result += "Industry Segment Name not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Industry Segment Name  blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 9) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.Group.findIndex((e: any) => this.common.ToLowerCase(e.GroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.GroupID = this.Group[this.Group.findIndex((e: any) => this.common.ToLowerCase(e.GroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].GroupMasterID;
                      } else {
                        element.Result += "Rate Contract Group not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Rate Contract Group blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 10 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.ZoneMaster.findIndex((e: any) => this.common.ToLowerCase(e.ZoneName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.ZoneId = this.ZoneMaster[this.ZoneMaster.findIndex((e: any) => this.common.ToLowerCase(e.ZoneName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].ZoneMasterID;
                    } else {
                      element.Result += "Zone not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 11 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  }
                  //else
                  if (index == 12 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.SubGroups.findIndex((e: any) => this.common.ToLowerCase(e.SiteSubGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteSubGroupMasterID = this.SubGroups[this.SubGroups.findIndex((e: any) => this.common.ToLowerCase(e.SiteSubGroupName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].SiteSubGroupMasterID;
                    } else {
                      element.Result += "SiteSubGroupName not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 13 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  }
                  //else
                  if (index == 14) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.Channels.findIndex((e: any) => this.common.ToLowerCase(e.ChannelName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.SiteChannelId = this.Channels[this.Channels.findIndex((e: any) => this.common.ToLowerCase(e.ChannelName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].ChannelMasterID;
                      } else {
                        element.Result += "ChannelName not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "ChannelName blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 15 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.ServiceType.findIndex((e: any) => this.common.ToLowerCase(e.ServiceTypeName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.ServiceTypeID = this.ServiceType[this.ServiceType.findIndex((e: any) => this.common.ToLowerCase(e.ServiceTypeName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].ServiceTypeID;
                    } else {
                      element.Result += "Service Type Name not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 16 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.Banks.findIndex((e: any) => this.common.ToLowerCase(e.BankName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteBankId = this.Banks[this.Banks.findIndex((e: any) => this.common.ToLowerCase(e.BankName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].OurCompanyBankMasterID;
                    } else {
                      element.Result += "Bank not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 17) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.Address1 = element[excelHIndex];
                    } else {
                      element.Result += "Address 1 blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 18 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.Address2 = element[excelHIndex];
                  }
                  //else
                  if (index == 19 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.City = element[excelHIndex];
                  }
                  //else
                  if (index == 20) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.State.findIndex((e: any) => this.common.ToLowerCase(e.StateName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.StateID = this.State[this.State.findIndex((e: any) => this.common.ToLowerCase(e.StateName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].StateMasterID;
                        await this.ComboLoad('District', SiteIndertUpdate.StateID);
                      } else {
                        element.Result += "State Name not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "State Name blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 21) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.District.findIndex((e: any) => this.common.ToLowerCase(e.DistrictName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.DistrictID = this.District[this.District.findIndex((e: any) => this.common.ToLowerCase(e.DistrictName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].DistrictMasterID;
                        await this.ComboLoad('Taluka', SiteIndertUpdate.StateID, SiteIndertUpdate.DistrictID);
                      } else {
                        element.Result += "District Name not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "District Name blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 22 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.Taluka.findIndex((e: any) => this.common.ToLowerCase(e.TalukaName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.TalukaID = this.Taluka[this.Taluka.findIndex((e: any) => this.common.ToLowerCase(e.TalukaName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].TalukaMasterID;
                      } else {
                        element.Result += "Taluka Name not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Taluka Name blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 23 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.PinCode = element[excelHIndex];
                  }
                  //else
                  if (index == 24 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.TelephoneNo = element[excelHIndex];
                  }
                  //else
                  if (index == 25) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.ContactPersonName = element[excelHIndex];
                    } else {
                      element.Result += "ContactPersonName blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 26 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ContactPersonNo = element[excelHIndex];
                  }
                  //else
                  if (index == 27) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.ContactPersonEmail = element[excelHIndex];
                    } else {
                      element.Result += "ContactPersonEmail blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 28) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.BillTypes.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.BillType = this.BillTypes[this.BillTypes.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))];
                      } else {
                        element.Result += "BillType not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "BillType blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 29 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.Compliance.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.Compliance = this.Compliance[this.Compliance.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))];
                    } else {
                      element.Result += "Compliance not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 30) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.PFApplicable = true;
                    } else {
                      SiteIndertUpdate.PFApplicable = false;
                    }
                  }
                  //else
                  if (index == 31) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.ESICApplicable = true;
                    } else {
                      SiteIndertUpdate.ESICApplicable = false;
                    }
                  }
                  //else
                  if (index == 32) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.PTApplicable = true;
                    } else {
                      SiteIndertUpdate.PTApplicable = false;
                    }
                  }
                  //else 
                  if (index == 33) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.LWFApplicable = true;
                    } else {
                      SiteIndertUpdate.LWFApplicable = false;
                    }
                  }
                  //else 
                  if (index == 34) {

                  }
                  //else
                  if (index == 35) {

                  }
                  //else
                  if (index == 36) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                      if (!isNaN(element[excelHIndex])) {
                        element[excelHIndex] = formatExcelDate(element[excelHIndex], this.datePipe)
                      }

                      if (isValidDate(element[excelHIndex])) {
                        SiteIndertUpdate.SiteStartDate = element[excelHIndex];
                      } else {
                        element.Result += "SiteStartDate allow formate DD MMM YYYY ex. 08 Apr 2026; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "SiteStartDate blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 37) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (!isNaN(element[excelHIndex])) {
                        element[excelHIndex] = formatExcelDate(element[excelHIndex], this.datePipe)
                      }
                      if (isValidDate(element[excelHIndex])) {
                        SiteIndertUpdate.SiteEndDate = element[excelHIndex];
                      } else {
                        element.Result += "SiteEndDate allow formate DD MMM YYYY ex. 08 Apr 2026; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "SiteEndDate blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 38) {

                  }
                  //else
                  if (index == 39) {

                  }
                  //else
                  if (index == 40) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.SiteOwner.findIndex((e: any) => this.common.ToLowerCase(e.SiteOwnerName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.SiteOwnerID = this.SiteOwner[this.SiteOwner.findIndex((e: any) => this.common.ToLowerCase(e.SiteOwnerName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].SiteOwnerMasterID;
                      } else {
                        element.Result += "SiteOwner not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "SiteOwner blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 41 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Latitude = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 42 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Longitude = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 43 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Radius = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 44 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Accuracy = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 45 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Altitude = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 46 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Heading = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 47 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsMocked = true;
                    } else {
                      SiteIndertUpdate.IsMocked = false;
                    }
                  }
                  //else
                  if (index == 48 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsAltitudeApplicable = true;
                    } else {
                      SiteIndertUpdate.IsAltitudeApplicable = false;
                    }
                  }
                  //else
                  if (index == 49 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.AltitudeRadius = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 50) {

                  }
                  //else
                  if (index == 51 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.AreaSqFt = element[excelHIndex];
                    }
                  }
                  //else
                  if (index == 52 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.MaterialChgVal = element[excelHIndex];
                  }
                  //else
                  if (index == 53 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.MaterialChargesType.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.MaterialChgType = this.MaterialChargesType[this.MaterialChargesType.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))];
                    } else {
                      element.Result += "MaterialChargeType not found; ";
                      this.recodecheck = false;
                    }
                  } else if (index == 54 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.MachineryChargesType.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.MachineryChgType = this.MachineryChargesType[this.MachineryChargesType.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))];
                    } else {
                      element.Result += "Machinery Charge Type not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 55 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.MachineryChgVal = element[excelHIndex];
                  }
                  //else
                  if (index == 56) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'datewise') {
                        SiteIndertUpdate.SalaryCalcType = 'D';
                      } else if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'monthwise') {
                        SiteIndertUpdate.SalaryCalcType = 'M';
                        SiteIndertUpdate.SalaryFrom = 1;
                        SiteIndertUpdate.SalaryTo = 0;
                      } else {
                        element.Result += "SalaryCalcType only allow Datewise or MonthWise; ";
                        this.recodecheck = false;
                      }
                    } else {
                      SiteIndertUpdate.SalaryCalcType = 'M';
                    }
                  }
                  //else
                  if (index == 57 && SiteIndertUpdate.SalaryCalcType == 'D') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (!isNaN(element[excelHIndex])) {
                        if (parseInt(element[excelHIndex].toString()) >= 2 && parseInt(element[excelHIndex].toString()) <= 28) {
                          SiteIndertUpdate.SalaryFrom = parseInt(element[excelHIndex].toString());
                          SiteIndertUpdate.SalaryTo = parseInt(element[excelHIndex].toString()) - 1;
                        } else {
                          element.Result += "Salary From only allow 2 to 28; ";
                          this.recodecheck = false;
                        }
                      } else {
                        element.Result += "Salary From only allow 2 to 28; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Salary From only allow 2 to 28; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 58) { }
                  //else
                  if (index == 59 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  }
                  //else
                  if (index == 60) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'datewise') {
                        SiteIndertUpdate.BillingCalcType = 'D';
                      } else if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'monthwise') {
                        SiteIndertUpdate.BillingCalcType = 'M';
                        SiteIndertUpdate.BillingFrom = 1;
                        SiteIndertUpdate.BillingTo = 0;
                      } else {
                        element.Result += "BillingCalcType only allow Datewise or MonthWise; ";
                        this.recodecheck = false;
                      }
                    } else {
                      SiteIndertUpdate.BillingCalcType = 'M';
                    }
                  }
                  //else
                  if (index == 61 && SiteIndertUpdate.SalaryCalcType == 'D') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (!isNaN(element[excelHIndex])) {
                        if (parseInt(element[excelHIndex].toString()) >= 2 && parseInt(element[excelHIndex].toString()) <= 28) {
                          SiteIndertUpdate.BillingFrom = parseInt(element[excelHIndex].toString());
                          SiteIndertUpdate.BillingTo = parseInt(element[excelHIndex].toString()) - 1;
                        } else {
                          element.Result = "Billing From only allow 2 to 28";
                          this.recodecheck = false;
                        }
                      } else {
                        element.Result = "Billing From only allow 2 to 28";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Billing From only allow 2 to 28; ";
                      this.recodecheck = false;
                    }
                  }
                  //else
                  if (index == 62) {

                  }
                  //else
                  if (index == 63) {

                  }
                  //else
                  if (index == 64) {

                  }
                  //else
                  if (index == 65) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsInternalPOCApplicable = true;
                    } else {
                      SiteIndertUpdate.IsInternalPOCApplicable = false;
                    }
                  }
                  else
                    if (index == 66 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.InternalPOCName = element[excelHIndex];
                    }
                  //else 
                  if (index == 67 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.InternalPOCMobileNo = element[excelHIndex];
                  }
                  //else
                  if (index == 68 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.InternalPOCMailId = element[excelHIndex];
                  }
                  //else
                  if (index == 69) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsClientPOCApplicable = true;
                    } else {
                      SiteIndertUpdate.IsClientPOCApplicable = false;
                    }
                  }
                  //else
                  if (index == 70 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ClientPOCName = element[excelHIndex];
                  }
                  //else
                  if (index == 71 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ClientPOCMobileNo = element[excelHIndex];
                  }
                  //else 
                  if (index == 72 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ClientPOCMailId = element[excelHIndex];
                  }
                  //else 
                  if (index == 73) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.SiteOracleCode = element[excelHIndex];
                    } else {
                      if (this.common.CompanyParameterValue.IsESSSiteMasterOracleCode) {
                        element.Result += "SiteOracleCode blank not allow; ";
                        this.recodecheck = false;
                      }
                    }
                  }
                  //else
                  if (index == 74 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.SiteAlternateCode = element[excelHIndex];
                  }
                  //else
                  if (index == 75) {

                  }
                  //else
                  if (index == 76 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.AttendanceThroughLoad.findIndex((e: any) => this.common.ToLowerCase(e.AttendanceThrough.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteAttendanceThrough = this.AttendanceThroughLoad[this.AttendanceThroughLoad.findIndex((e: any) => this.common.ToLowerCase(e.AttendanceThrough.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].AttendanceThrough;
                    } else {
                      element.Result += "SiteAttendanceThrough not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 77 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.LeaveSalaryCycleLoad.findIndex((e: any) => this.common.ToLowerCase(e.LeaveSalarCycle.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteLeaveSalarCycle = this.LeaveSalaryCycleLoad[this.LeaveSalaryCycleLoad.findIndex((e: any) => this.common.ToLowerCase(e.LeaveSalarCycle.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].LeaveSalarCycle;
                    } else {
                      element.Result += "SiteLeaveSalarCycle not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 78 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.LeaveSalaryPayoutLoad.findIndex((e: any) => this.common.ToLowerCase(e.LeaveSalary.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteLeaveSalary = this.LeaveSalaryPayoutLoad[this.LeaveSalaryPayoutLoad.findIndex((e: any) => this.common.ToLowerCase(e.LeaveSalary.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].LeaveSalary;
                    } else {
                      element.Result += "SiteLeaveSalary not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 79 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.PayoutBonusesCycleLoad.findIndex((e: any) => this.common.ToLowerCase(e.PayoutBonusesCycle.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SitePayoutBonusesCycle = this.PayoutBonusesCycleLoad[this.PayoutBonusesCycleLoad.findIndex((e: any) => this.common.ToLowerCase(e.PayoutBonusesCycle.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].PayoutBonusesCycle;
                    } else {
                      element.Result += "SitePayoutBonusesCycle not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 80 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.PayoutBonusLoad.findIndex((e: any) => this.common.ToLowerCase(e.PayoutBonus.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SitePayoutBonus = this.PayoutBonusLoad[this.PayoutBonusLoad.findIndex((e: any) => this.common.ToLowerCase(e.PayoutBonus.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].PayoutBonus;
                    } else {
                      element.Result += "SitePayoutBonus not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 81 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.GratuityLoad.findIndex((e: any) => this.common.ToLowerCase(e.Gratuity.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteGratuity = this.GratuityLoad[this.GratuityLoad.findIndex((e: any) => this.common.ToLowerCase(e.Gratuity.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].Gratuity;
                    } else {
                      element.Result += "SiteGratuity not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 82 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.UniformLoad.findIndex((e: any) => this.common.ToLowerCase(e.Uniforms.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteUniforms = this.UniformLoad[this.UniformLoad.findIndex((e: any) => this.common.ToLowerCase(e.Uniforms.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].Uniforms;
                    } else {
                      element.Result += "SiteUniforms not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 83) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.SiteIsUniformsDeposit = true;
                    } else {
                      SiteIndertUpdate.SiteIsUniformsDeposit = false;
                    }
                  }
                  //else 
                  if (index == 84 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.MinimumWageIndustryLoad.findIndex((e: any) => this.common.ToLowerCase(e.MinimumWageIndustry.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteMinimumWageIndustry = this.MinimumWageIndustryLoad[this.MinimumWageIndustryLoad.findIndex((e: any) => this.common.ToLowerCase(e.MinimumWageIndustry.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].MinimumWageIndustry;
                    } else {
                      element.Result += "SiteMinimumWageIndustry not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 85 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.MinimumWageZoneLoad.findIndex((e: any) => this.common.ToLowerCase(e.MinimumWageZone.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteMinimumWageZone = this.MinimumWageZoneLoad[this.MinimumWageZoneLoad.findIndex((e: any) => this.common.ToLowerCase(e.MinimumWageZone.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].MinimumWageZone;
                    } else {
                      element.Result += "SiteMinimumWageZone not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 86 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.WageStrutureLoad.findIndex((e: any) => this.common.ToLowerCase(e.MinimumWageStructure.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                      SiteIndertUpdate.SiteMinimumWageStructure = this.WageStrutureLoad[this.WageStrutureLoad.findIndex((e: any) => this.common.ToLowerCase(e.MinimumWageStructure.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].MinimumWageStructure;
                    } else {
                      element.Result += "SiteMinimumWageStructure not found; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 87 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'site' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'client') {
                      SiteIndertUpdate.SiteBillTo = element[excelHIndex];
                    } else {
                      element.Result += "SiteBillTo only allow client or site; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 88 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'site' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'client') {
                      SiteIndertUpdate.SiteShipTo = element[excelHIndex];
                    } else {
                      element.Result += "SiteShipTo only allow client or site; ";
                      this.recodecheck = false;
                    }
                  }
                  //else 
                  if (index == 89) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.SiteAutoMail = true;
                    } else {
                      SiteIndertUpdate.SiteAutoMail = false;
                    }
                  }
                  //else 
                  if (index == 90) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.SitePlaceOfSupplyApplicable = true;
                    } else {
                      SiteIndertUpdate.SitePlaceOfSupplyApplicable = false;
                    }
                  }
                  //else 
                  if (index == 91 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.Narration = element[excelHIndex];
                  }
                  //else 
                  if (index == 92) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsClientAttendanceInformationMail = true;
                    } else {
                      SiteIndertUpdate.IsClientAttendanceInformationMail = false;
                    }
                  }
                  if (index == 93) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.FinancialBranch.findIndex(e => this.common.ToLowerCase(e.DivisionName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, ''))) >= 0) {
                        SiteIndertUpdate.FinancialBranchID = this.FinancialBranch[this.FinancialBranch.findIndex(e => this.common.ToLowerCase(e.DivisionName.replace(/\s+/g, '')) == this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')))].DivisionMasterId;
                      } else {
                        element.Result += "Financial branch not found; ";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result += "Financial branch blank not allow; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 94) {
                    if ((!isNaN(element[excelHIndex]) && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) > 0 && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) <= 999999)) {
                      SiteIndertUpdate.BillDutyDivisionBy = parseInt(element[excelHIndex].toString().replace(/\s+/g, ''));
                    } else {
                      element.Result += "BillDutyDivisionBy must be between 1 to 999999; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 95) {
                    if ((!isNaN(element[excelHIndex]) && (parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) == 6 || parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) == 7))) {
                      SiteIndertUpdate.WeeklyOffDivideBy = parseInt(element[excelHIndex].toString().replace(/\s+/g, ''));
                    } else {
                      element.Result += "WeeklyOffDivideBy must be 6 or 7; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 96) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'new' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'lateral') {
                        SiteIndertUpdate.SiteType = element[excelHIndex].toString().replace(/\s+/g, '');
                      } else {
                        element.Result += "NewLateralSite must be New or Lateral; ";
                        this.recodecheck = false;
                      }
                    } else {
                      SiteIndertUpdate.SiteType = 'New';
                    }
                  }
                  if (index == 97 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if ((!isNaN(element[excelHIndex]) && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) >= 1 && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) <= 31)) {
                      SiteIndertUpdate.AttendanceDateValue = parseInt(element[excelHIndex].toString().replace(/\s+/g, ''));
                    } else {
                      element.Result += "AttendanceDate must be between 1 to 31; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 98 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if ((!isNaN(element[excelHIndex]) && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) >= 1 && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) <= 31)) {
                      SiteIndertUpdate.SalaryDateValue = parseInt(element[excelHIndex].toString().replace(/\s+/g, ''));
                    } else {
                      element.Result += "SalaryDate must be between 1 to 31; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 99 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if ((!isNaN(element[excelHIndex]) && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) >= 1 && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) <= 31)) {
                      SiteIndertUpdate.SalaryPaymentDateValue = parseInt(element[excelHIndex].toString().replace(/\s+/g, ''));
                    } else {
                      element.Result += "SalaryPayDate must be between 1 to 31; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 100 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if ((!isNaN(element[excelHIndex]) && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) >= 1 && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) <= 31)) {
                      SiteIndertUpdate.BillingDateValue = parseInt(element[excelHIndex].toString().replace(/\s+/g, ''));
                    } else {
                      element.Result += "BillingDate must be between 1 to 31; ";
                      this.recodecheck = false;
                    }
                  }
                  if (index == 101 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.Active = true;
                    } else {
                      SiteIndertUpdate.Active = false;
                    }
                  }
                  //else 
                  if (index == 102 && SiteIndertUpdate.SelectType == 'EI') {
                    if (!isNaN(element[excelHIndex]) && parseInt(element[excelHIndex].toString().replace(/\s+/g, '')) > 0) {
                      //site manpower
                      for (let rindex2 = 0; rindex2 < this.excelData2.filter((e: any) => e[this.excelHeader2.findIndex((e: any) => this.common.ToLowerCase(e).replace(/\s+/g, '') == this.common.ToLowerCase(this.excelHeader2[excelHIndex]).replace(/\s+/g, ''))] == parseInt(element[excelHIndex])).length; rindex2++, rindex2e++) {
                        this.excelDataResult2[rindex2e] = {};
                        SiteIndertUpdate.ESS_SiteManpower[rindex2] = {
                          DesignationId: null,
                          DutyId: null,
                          NoOfPerson: null,
                          SalaryCalcOn: null,
                          SalaryCalcDays: null,
                          BillingCalcOn: null,
                          BillingCalcDays: null,
                          ProductDescription: null,
                        };
                        const element2 = this.excelData2.filter((e: any) => e[this.excelHeader2.findIndex((e: any) => this.common.ToLowerCase(e).replace(/\s+/g, '') == this.common.ToLowerCase(this.excelHeader2[excelHIndex]).replace(/\s+/g, ''))] == parseInt(element[excelHIndex]))[rindex2];
                        element2.Result = "";
                        for (const [index2, helement2] of this.ExcelHeaders[this.ExcelHeadersIndex].HeadersSiteManpower.entries()) {
                          this.excelDataResult2[rindex2e][helement2] = element2[index2];
                          const excelHIndex2 = this.excelHeader2.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement2.replace(/\s+/g, '')));
                          //if (excelHIndex2 >= 0 && this.recodecheck) {
                          if (excelHIndex2 >= 0) {
                            if (index2 == 0) {
                            }
                            //else 
                            if (index2 == 1) {
                              if (this.DesignationLoad.findIndex((e: any) => this.common.ToLowerCase(e.DesignationName.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, ''))) >= 0) {
                                SiteIndertUpdate.ESS_SiteManpower[rindex2].DesignationId = this.DesignationLoad[this.DesignationLoad.findIndex((e: any) => this.common.ToLowerCase(e.DesignationName.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, '')))].DesignationMasterID;
                              } else {
                                element.Result += "Designation not found - Sheet2; ";
                                element2.Result += "Designation not found - Sheet2; ";
                                this.recodecheck = false;
                              }
                            }
                            //else 
                            if (index2 == 2) {
                              if (this.DutyLoad.findIndex((e: any) => this.common.ToLowerCase(e.DutyName.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, ''))) >= 0) {
                                SiteIndertUpdate.ESS_SiteManpower[rindex2].DutyId = this.DutyLoad[this.DutyLoad.findIndex((e: any) => this.common.ToLowerCase(e.DutyName.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, '')))].DutyMasterID;
                              } else {
                                element.Result += "Duty not found - Sheet2; ";
                                element2.Result += "Duty not found - Sheet2; ";
                                this.recodecheck = false;
                              }
                            } //else 
                            if (index2 == 3) {
                              if ((!isNaN(element2[excelHIndex2]) && parseInt(element2[excelHIndex2].toString().replace(/\s+/g, '')) > 0)) {
                                SiteIndertUpdate.ESS_SiteManpower[rindex2].NoOfPerson = element2[excelHIndex2].toString().replace(/\s+/g, '');
                              } else {
                                element.Result += "NoOfPerson muster be greter then 0 - Sheet2; ";
                                element2.Result += "NoOfPerson muster be greter then 0 - Sheet2; ";
                                this.recodecheck = false;
                              }
                            }
                            //else 
                            if (index2 == 4) {
                              if (element2[excelHIndex2] != null && element2[excelHIndex2].toString().replace(/\s+/g, '') != '') {
                                if (this.SalaryBillingCalcOn.findIndex((e: any) => this.common.ToLowerCase(e.Name.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, ''))) >= 0) {
                                  SiteIndertUpdate.ESS_SiteManpower[rindex2].SalaryCalcOn = this.SalaryBillingCalcOn[this.SalaryBillingCalcOn.findIndex((e: any) => this.common.ToLowerCase(e.Name.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, '')))].Value;
                                } else {
                                  element.Result += "SalaryCalcOn not found - Sheet2; ";
                                  element2.Result += "SalaryCalcOn not found - Sheet2; ";
                                  this.recodecheck = false;
                                }
                              } else {
                                element.Result += "SalaryCalcOn blank not allow - Sheet2; ";
                                element2.Result += "SalaryCalcOn blank not allow - Sheet2; ";
                                this.recodecheck = false;
                              }
                            }
                            //else 
                            if (index2 == 5) {
                              if (this.common.ToLowerCase(SiteIndertUpdate.ESS_SiteManpower[rindex2].SalaryCalcOn) == 'f' || this.common.ToLowerCase(SiteIndertUpdate.ESS_SiteManpower[rindex2].SalaryCalcOn) == 's') {
                                if ((!isNaN(element2[excelHIndex2]) && parseInt(element2[excelHIndex2].toString().replace(/\s+/g, '')) > 0 && parseInt(element2[excelHIndex2].toString().replace(/\s+/g, '')) <= 31)) {
                                  SiteIndertUpdate.ESS_SiteManpower[rindex2].SalaryCalcDays = parseInt(element2[excelHIndex2].toString().replace(/\s+/g, ''));
                                } else {
                                  element.Result += "SalaryCalcDays must be between 1 to 31 - Sheet2; ";
                                  element2.Result += "SalaryCalcDays must be between 1 to 31 - Sheet2; ";
                                  this.recodecheck = false;
                                }
                              } else {
                                SiteIndertUpdate.ESS_SiteManpower[rindex2].SalaryCalcDays = 0;
                              }
                            }
                            //else
                            if (index2 == 6) {
                              if (element2[excelHIndex2] != null && element2[excelHIndex2].toString().replace(/\s+/g, '') != '') {
                                if (this.SalaryBillingCalcOn.findIndex((e: any) => this.common.ToLowerCase(e.Name.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, ''))) >= 0) {
                                  SiteIndertUpdate.ESS_SiteManpower[rindex2].BillingCalcOn = this.SalaryBillingCalcOn[this.SalaryBillingCalcOn.findIndex((e: any) => this.common.ToLowerCase(e.Name.replace(/\s+/g, '')) == this.common.ToLowerCase(element2[excelHIndex2].toString().replace(/\s+/g, '')))].Value;
                                } else {
                                  element.Result += "BillingCalcOn not found - Sheet2; ";
                                  element2.Result += "BillingCalcOn not found - Sheet2; ";
                                  this.recodecheck = false;
                                }
                              } else {
                                element.Result += "BillingCalcOn blank not allow - Sheet2; ";
                                element2.Result += "BillingCalcOn blank not allow - Sheet2; ";
                                this.recodecheck = false;
                              }
                            }
                            //else 
                            if (index2 == 7) {
                              if (this.common.ToLowerCase(SiteIndertUpdate.ESS_SiteManpower[rindex2].BillingCalcOn) == 'f' || this.common.ToLowerCase(SiteIndertUpdate.ESS_SiteManpower[rindex2].BillingCalcOn) == 's') {
                                if ((!isNaN(element2[excelHIndex2]) && parseInt(element2[excelHIndex2].toString().replace(/\s+/g, '')) > 0 && parseInt(element2[excelHIndex2].toString().replace(/\s+/g, '')) <= 31)) {
                                  SiteIndertUpdate.ESS_SiteManpower[rindex2].BillingCalcDays = parseInt(element2[excelHIndex2].toString().replace(/\s+/g, ''));
                                } else {
                                  element.Result += "BillingCalcDays must be between 1 to 31 - Sheet2; ";
                                  element2.Result += "BillingCalcDays must be between 1 to 31 - Sheet2; ";
                                  this.recodecheck = false;
                                }
                              } else {
                                SiteIndertUpdate.ESS_SiteManpower[rindex2].BillingCalcDays = 0;
                              }
                            }
                            //else 
                            if (index2 == 8) {
                              if (element2[excelHIndex2] != null && element2[excelHIndex2].toString().replace(/\s+/g, '') != '') {
                                SiteIndertUpdate.ESS_SiteManpower[rindex2].ProductDescription = element2[excelHIndex2].toString();
                              } else {
                                element.Result += "ProductDescription blank not allow - Sheet2; ";
                                element2.Result += "ProductDescription blank not allow - Sheet2; ";
                                this.recodecheck = false;
                              }
                            }
                          }
                        }

                        this.excelDataResult2[rindex2e].Result = element2.Result;
                      }

                      //site shift
                      for (let rindex3 = 0; rindex3 < this.excelData3.filter((e: any) => e[this.excelHeader3.findIndex((e: any) => this.common.ToLowerCase(e).replace(/\s+/g, '') == this.common.ToLowerCase(this.excelHeader3[excelHIndex]).replace(/\s+/g, ''))] == parseInt(element[excelHIndex])).length; rindex3++, rindex3e++) {
                        this.excelDataResult3[rindex3e] = {};
                        SiteIndertUpdate.ESS_ShiftDetails[rindex3] = {
                          DesignationId: null,
                          DutyId: null,
                          ShiftId: null,
                          ShiftWiseNoOfPerson: null,
                        };
                        const element3 = this.excelData3.filter((e: any) => e[this.excelHeader3.findIndex((e: any) => this.common.ToLowerCase(e).replace(/\s+/g, '') == this.common.ToLowerCase(this.excelHeader3[excelHIndex]).replace(/\s+/g, ''))] == parseInt(element[excelHIndex]))[rindex3];
                        element3.Result = "";
                        for (const [index3, helement3] of this.ExcelHeaders[this.ExcelHeadersIndex].HeadersShiftDetail.entries()) {
                          this.excelDataResult3[rindex3e][helement3] = element3[index3];
                          const excelHIndex3 = this.excelHeader3.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement3.replace(/\s+/g, '')));
                          //if (excelHIndex3 >= 0 && this.recodecheck) {
                          if (excelHIndex3 >= 0) {
                            if (index3 == 0) {
                            }
                            //else 
                            if (index3 == 1) {
                              if (this.DesignationLoad.findIndex((e: any) => this.common.ToLowerCase(e.DesignationName.replace(/\s+/g, '')) == this.common.ToLowerCase(element3[excelHIndex3].toString().replace(/\s+/g, ''))) >= 0) {
                                SiteIndertUpdate.ESS_ShiftDetails[rindex3].DesignationId = this.DesignationLoad[this.DesignationLoad.findIndex((e: any) => this.common.ToLowerCase(e.DesignationName.replace(/\s+/g, '')) == this.common.ToLowerCase(element3[excelHIndex3].toString().replace(/\s+/g, '')))].DesignationMasterID;
                              } else {
                                element.Result += "Designation not found - Sheet3; ";
                                element3.Result += "Designation not found - Sheet3; ";
                                this.recodecheck = false;
                              }
                            }
                            //else 
                            if (index3 == 2) {
                              if (this.DutyLoad.findIndex((e: any) => this.common.ToLowerCase(e.DutyName.replace(/\s+/g, '')) == this.common.ToLowerCase(element3[excelHIndex3].toString().replace(/\s+/g, ''))) >= 0) {
                                SiteIndertUpdate.ESS_ShiftDetails[rindex3].DutyId = this.DutyLoad[this.DutyLoad.findIndex((e: any) => this.common.ToLowerCase(e.DutyName.replace(/\s+/g, '')) == this.common.ToLowerCase(element3[excelHIndex3].toString().replace(/\s+/g, '')))].DutyMasterID;
                              } else {
                                element.Result += "Duty not found - Sheet3; ";
                                element3.Result += "Duty not found - Sheet3; ";
                                this.recodecheck = false;
                              }
                            }
                            //else 
                            if (index3 == 3) {
                              if (this.Shift.findIndex((e: any) => this.common.ToLowerCase(e.ShiftTitle.replace(/\s+/g, '')) == this.common.ToLowerCase(element3[excelHIndex3].toString().replace(/\s+/g, ''))) >= 0) {
                                SiteIndertUpdate.ESS_ShiftDetails[rindex3].ShiftId = this.Shift[this.Shift.findIndex((e: any) => this.common.ToLowerCase(e.ShiftTitle.replace(/\s+/g, '')) == this.common.ToLowerCase(element3[excelHIndex3].toString().replace(/\s+/g, '')))].ShiftMasterID;
                              } else {
                                element.Result += "Shift not found - Sheet3; ";
                                element3.Result += "Shift not found - Sheet3; ";
                                this.recodecheck = false;
                              }
                            }
                            //else 
                            if (index3 == 4) {
                              if ((!isNaN(element3[excelHIndex3]) && parseInt(element3[excelHIndex3].toString().replace(/\s+/g, '')) > 0)) {
                                SiteIndertUpdate.ESS_ShiftDetails[rindex3].ShiftWiseNoOfPerson = element3[excelHIndex3].toString().replace(/\s+/g, '');
                              } else {
                                element.Result += "NoOfPerson muster be greter then 0 - Sheet2; ";
                                element3.Result += "NoOfPerson muster be greter then 0 - Sheet2; ";
                                this.recodecheck = false;
                              }
                            }
                          }
                        }
                        this.excelDataResult3[rindex3e].Result = element3.Result;
                      }

                      SiteIndertUpdate.ESS_SiteManpower.forEach((element4: any) => {
                        if (this.recodecheck) {
                          if (parseInt(element4.NoOfPerson) != SiteIndertUpdate.ESS_ShiftDetails.filter((e: any) => e.DesignationId == element4.DesignationId && e.DutyId == element4.DutyId).reduce((total: number, e: any) => total + (parseInt(e.ShiftWiseNoOfPerson) || 0), 0)) {
                            this.recodecheck = false;
                            element.Result += "Site manpower or shift manpower missmatch - Sheet2; ";
                          }
                        }
                      });
                    }
                  }
                };
              }
              if (this.recodecheck) {
                await this.SaveandUpdateSiteMaster(SiteIndertUpdate, element);
              }
              this.excelDataResult[rindex].Result = element.Result;
            }
          }
          this.download.exportToExcel(this.excelDataResult, "Result", this.excelDataResult2, this.excelDataResult3);
          this.reset();
        }
      });
    }
  }

  async SaveFromExcelShiftGroup(element: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.shift.ESS_ShiftGroupMaster_Insert({
        SelectType: (element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[0].replace(/\s+/g, '')))] > 0) ? 'Update' : 'Insert',
        ESS_ShiftGroupMasterId: element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[0].replace(/\s+/g, '')))],
        ShiftGroupName: element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, '')))],
      }).subscribe({
        next: (response) => {
          element.Result = response.Error_Message;
          if (response.Error_Code == '548' || response.Error_Code == '549') {
            this.anyonesuccess = true;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }

  async SaveLeaveDetail(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let leavedata = data.map((e: any) => ({
        EmpMasterId: e['Emp Master ID'],
        LeaveMasterId: e['Leave Master ID'],
        InputType: e['Input Type'],
        YearName: '2026',
        Value: Number(e['Value']),
        Description: e['Remark'] ? e['Remark'] : ''
      }))
      console.log(leavedata);
      this.leave.LeaveClosingBalanceDetail({
        SelectType: 'I',
        ESS_EmpMonthlyLeaveCredited: leavedata
      }).subscribe({
        next: (response) => {
          if (response.Errorcode == "01") {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.ErrorMsg;
            modalRef.result.then((result: any) => {
              if (result) {
                this.activeModal.close(true);
              }
            });
          } else {
            this.isDisabled = false;
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.ErrorMsg;
            modalRef.result.then((result: any) => {
              this.activeModal.close(true);
            });
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  async SaveFromExcelSiteType(element: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.sitetype.SiteTypeInsert({
        SelectType: (element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[0].replace(/\s+/g, '')))] > 0) ? 'Update' : 'Insert',
        SiteTypeMasterId: element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[0].replace(/\s+/g, '')))],
        SiteTypeName: element[this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, '')))],
        Active: true,
      }).subscribe({
        next: (response) => {
          element.Result = response.Error_Message;
          if (response.Error_Code == '637' || response.Error_Code == '636') {
            this.anyonesuccess = true;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }

  async SaveandUpdateShiftMaster(Saveelement: any, element: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      this.shiftmaster.ShiftMasterInsertUpdate(Saveelement).subscribe({
        next: async (response) => {
          element.Result = response.Error_Message;
          this.isDisabled = false;
          if (response.Error_Message == '01') {
            this.anyonesuccess = true;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error: any) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }

  async SaveandUpdateSiteMaster(Saveelement: any, element: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      this.locationservice.SiteInsert(Saveelement).subscribe({
        next: async (response) => {
          element.Result = response.Error_Message;
          this.isDisabled = false;
          if (response.Error_Message == '01') {
            this.anyonesuccess = true;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error: any) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }


  async loadSiteData(BranchID: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      if (BranchID == null) {
        this.IndustrySeg = [];
        this.ServiceType = [];
        this.RegionMaster = [];
        this.BranchMaster = [];
        this.CustomerGroup = [];
        this.FinancialBranch = [];
        this.ReportTypeMaster = [];
        this.Group = [];
        this.State = [];
        this.DesignationLoad = [];
        this.DutyLoad = [];
        this.Channels = [];
        this.Banks = [];
        this.AttendanceThroughLoad = [];
        this.LeaveSalaryCycleLoad = [];
        this.LeaveSalaryPayoutLoad = [];
        this.PayoutBonusesCycleLoad = [];
        this.PayoutBonusLoad = [];
        this.GratuityLoad = [];
        this.UniformLoad = [];
        this.MinimumWageIndustryLoad = [];
        this.MinimumWageZoneLoad = [];
        this.WageStrutureLoad = [];
        this.Groups = [];
        this.SubGroups = [];
        this.FilteredSubGroups = [];
        this.Shift = [];
      } else if (BranchID > 0) {
        this.SiteOwner = [];
        this.ZoneMaster = [];
      }
      this.locationservice.SiteComboLoad({ ESS_SiteMasterId: '', SelecteType: 1, BranchID: BranchID, UserId: null }).subscribe({
        next: (data) => {
          if (BranchID == null) {
            this.IndustrySeg = data.IndustrySegmentMaster;
            this.ServiceType = data.ServiceTypeMaster;
            this.RegionMaster = data.RegionMaster;
            if (!this.common.CompanyParameterValue.CCCode) {
              this.BranchMaster = data.BranchMaster;
            }
            this.CustomerGroup = data.ClientGroupMaster;
            this.FinancialBranch = data.financialBranch;
            this.ReportTypeMaster = data.ReportTypeMaster;
            this.Group = data.GroupMaster;
            this.State = data.StateMaster;
            this.DesignationLoad = data.DesignationMaster;
            this.DutyLoad = data.DutyMaster;
            this.Channels = data.ChannelMaster;
            this.Banks = data.SiteBankMaster;
            this.AttendanceThroughLoad = data.AttendanceThrough;
            this.LeaveSalaryCycleLoad = data.LeaveSalarCycle;
            this.LeaveSalaryPayoutLoad = data.LeaveSalary;
            this.PayoutBonusesCycleLoad = data.PayoutBonusesCycle;
            this.PayoutBonusLoad = data.PayoutBonus;
            this.GratuityLoad = data.Gratuity;
            this.UniformLoad = data.Uniforms;
            this.MinimumWageIndustryLoad = data.MinimumWageIndustry;
            this.MinimumWageZoneLoad = data.MinimumWageZone;
            this.WageStrutureLoad = data.MinimumWageStructure;
            this.Groups = data.SiteGroupMaster;
            this.SubGroups = data.SiteSubGroupMaster;
            this.FilteredSubGroups = data.SiteSubGroupMaster;
            this.Shift = data.ShiftMaster;
          } else if (BranchID > 0) {
            this.SiteOwner = data.siteowner;
            this.ZoneMaster = data.ZoneMaster;
          }

          this.isDisabled = false
          resolve(true);
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false
          resolve(error);
          console.error('Error:', error);
        },
      });
    });
  }

  async BillCustLoad(CustGrpId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      this.BillingCustomer = [];
      this.locationservice.BillCustLoad({ SelectType: 1, ClientGroupMasterId: CustGrpId }).subscribe({
        next: (data) => {
          if (data.Table.length > 0) {
            this.BillingCustomer = data.Table;
          }
          this.isDisabled = false
          resolve(true);
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false
          resolve(error);
          console.error('Error:', error);
        },
      });
    });
  }

  async ComboLoad(Combotype: String, Stateid = 0, DistrictId = 0): Promise<any> {
    if (Combotype == 'District') {
      this.District = [];
    } else if (Combotype == 'Taluka') {
      this.Taluka = [];
    } else if (Combotype == 'SiteTypeMaster') {
      this.SiteType = [];
    } else if (Combotype == 'ShiftGroup') {
      this.ShiftGroup = [];
    }
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      this.comboload.ComboLoad({
        'Combotype': Combotype,
        'StateId': (Combotype == 'District') ? Stateid : 0,
        'DistrictId': (Combotype == 'Taluka') ? DistrictId : 0
        // 'EmpType': 'front'
      }).subscribe({
        next: (response) => {
          if (Combotype == 'District') {
            this.District = response.ComboLoad;
          } else if (Combotype == 'Taluka') {
            this.Taluka = response.ComboLoad;
          } else if (Combotype == 'SiteTypeMaster') {
            this.SiteType = response.ComboLoad;
          } else if (Combotype == 'ShiftGroup') {
            this.ShiftGroup = response.ComboLoad;
          }
          this.isDisabled = false;
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          resolve(error);
        },
      });
    });
  }

  close() {
    this.activeModal.close(this.anyonesuccess);
  }
}

export function isValidDate(input: string): boolean {
  if (!input || typeof input !== 'string') return false;

  const monthMap: { [key: string]: boolean } = {
    'jan': true, 'january': true,
    'feb': true, 'february': true,
    'mar': true, 'march': true,
    'apr': true, 'april': true,
    'may': true,
    'jun': true, 'june': true,
    'jul': true, 'july': true,
    'aug': true, 'august': true,
    'sep': true, 'september': true,
    'oct': true, 'october': true,
    'nov': true, 'november': true,
    'dec': true, 'december': true
  };

  const parts = input.trim().split(' ');
  if (parts.length !== 3) return false;

  const day = parseInt(parts[0], 10);
  const month = parts[1].toLowerCase();
  const year = parseInt(parts[2], 10);

  if (isNaN(day) || isNaN(year)) return false;
  if (day < 1 || day > 31) return false;
  if (year < 1900 || year > 2100) return false;
  if (!monthMap[month]) return false;

  return true;
}

export function formatExcelDate(excelDate: number, datePipe: DatePipe): string {
  if (!excelDate || excelDate <= 0) return '';

  // Convert Excel serial to JavaScript Date
  const jsDate = new Date((excelDate - 25569) * 86400000);

  // Format as 'DD MMM YYYY'
  return datePipe.transform(jsDate, 'dd MMM yyyy') || '';
}

export function formatExcelTimeTo24Hour(excelTime: number): string {
  if (!excelTime && excelTime !== 0) return '';

  // Calculate total minutes in the day
  const totalMinutes = excelTime * 1440; // 24 * 60 = 1440

  // Get hours and minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);

  // Format with leading zeros
  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${paddedHours}:${paddedMinutes}`;
}

